import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy ".html" address: permanent redirect to /datenschutz.
export const Route = createFileRoute("/datenschutz.html")({
  loader: () => {
    throw redirect({ to: "/datenschutz", statusCode: 301 });
  },
});
